import ImageComponent from '@components/common/ImageComponent/ImageComponent';
import ivclass from '@invideoio/web-shared/Modules/IVClass';
import { Testimonials } from 'src/types';
import Testimony from './testimony';
import PrevButton from '@components/slider/PrevButton';
import NextButton from '@components/slider/NextButton';
import Slider from '@components/slider/Index';
import { Fragment, useContext } from 'react';
import { StateContext } from '@store/store';

interface TestimonialsProps {
  testimonialState: Testimonials;
}

const Testimonials = ({ testimonialState }: TestimonialsProps) => {
  const globalState = useContext(StateContext);

  const { platform } = globalState;
  return (
    <section
      className={ivclass(
        'xl:iv-mx-[140px] lg:iv-mx-40 md:iv-mx-25 sm:iv-mx-20',
      )}
    >
      <h2
        className={ivclass(
          'xl:iv-text-heading-4xl iv-text-heading-2xl sm:iv-text-heading-xs',
          'xl:iv-m-heading-4xl iv-m-heading-2xl sm:iv-m-heading-xs',
          'iv-text-grey-100',
          'iv-font-extrabold',
        )}
      >
        People
        <span
          className={ivclass(
            'iv-relative',
            'xl:iv-top-[6px] iv-top-[4px] sm-iv-top-0',
            'xl:iv-ml-20 iv-ml-15 iv-mr-5 sm:iv-ml-9 sm:iv-mr-3',
            'xl:iv-h-[72px] iv-h-[54px] sm:iv-h-[28px]',
            'xl:iv-w-[74px] iv-w-[55px] sm:iv-w-[28px]',
            'iv-inline-block',
          )}
        >
          <ImageComponent
            elementype="native"
            src={`${process.env.NEXT_PUBLIC_SHARED_CDN_URL}/logos/invideo-logo-heart.svg`}
            alt="logo"
            loading="lazy"
            width="74"
            height="72"
          />
        </span>{' '}
        invideo
      </h2>
      <div className={ivclass('iv-mt-75 iv-overflow-hidden')}>
        <Slider
          renderButtons={(
            scrollPrev,
            scrollNext,
            prevBtnEnabled,
            nextBtnEnabled,
          ) =>
            platform === 'mobile' || platform === 'tablet' ? (
              <Fragment />
            ) : (
              <Fragment>
                <PrevButton
                  clickHandler={scrollPrev}
                  isEndReached={prevBtnEnabled}
                />
                <NextButton
                  clickHandler={scrollNext}
                  isEndReached={nextBtnEnabled}
                />
              </Fragment>
            )
          }
        >
          {testimonialState?.TestimonialCard?.map((testimony, i) => (
            <div key={i} className="iv-relative">
              <Testimony testimony={testimony} />
            </div>
          ))}
        </Slider>
      </div>
    </section>
  );
};

export default Testimonials;
